import {
    Pagination,
    styled,
    Table,
    TableBody,
    TableCell as MuiTableCell,
    TableContainer,
    TableHead,
    TableRow as MuiTableRow,
    Typography
} from '@mui/material';
import { AncillaryHoursPastCyclesDto } from '../../../lib/dtos/AncillaryHoursPastCyclesDto';
import useGetPaginatedData from '../../../lib/hooks/use-pagination-data';
import theme from '../../../theme';
import { useScreenLargerThan } from '../../../lib/hooks/breakpoint-hooks';
import NotesReadOnlyModal from '../../InvoicingAndPayroll/Modals/NotesReadOnlyModal';

export type PastCyclesAncillaryHoursTableProps = {
    invoiceCycleId: string;
};

const PastCyclesAncillaryHoursTable = ({ invoiceCycleId }: PastCyclesAncillaryHoursTableProps) => {
    const isLargerThanMedium = useScreenLargerThan('md');
    const { data, paginationHandler } = useGetPaginatedData<AncillaryHoursPastCyclesDto>(
        `ancillary-hours/invoice-cycle/${invoiceCycleId}`
    );
    const TableCellMobile = styled(TableCell)({
        backgroundColor: theme.palette.listItemBackground.shade,
        width: '38%',
        paddingRight: '0',
        paddingLeft: '2%'
    });

    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    {isLargerThanMedium && (
                        <TableRow>
                            <TableCell
                                sx={{ backgroundColor: (t) => t.palette.listItemBackground.shade }}>
                                <Typography fontSize={14} fontWeight="700">
                                    Ancillary Hours
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography
                                    fontSize={13}
                                    color={(t) => t.palette.cardSubtitle.main}
                                    fontWeight={'600'}>
                                    Activity Minutes
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography
                                    fontSize={13}
                                    color={(t) => t.palette.cardSubtitle.main}
                                    fontWeight={'600'}>
                                    Activity
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    fontSize={13}
                                    color={(t) => t.palette.cardSubtitle.main}
                                    fontWeight={'600'}>
                                    Notes
                                </Typography>
                            </TableCell>
                        </TableRow>
                    )}

                    {!isLargerThanMedium && (
                        <TableRow>
                            <TableCellMobile>
                                <Typography fontSize={14} fontWeight="700">
                                    Ancillary Hours
                                </Typography>
                            </TableCellMobile>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    )}
                </TableHead>
                {isLargerThanMedium && data && (
                    <TableBody>
                        {data.data.map((ch) => (
                            <TableRow key={ch.id}>
                                <TableCell>
                                    <Typography fontSize={14} fontWeight={'600'}>
                                        {new Date(ch.date).toLocaleDateString()}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography fontSize={14} fontWeight={'600'}>
                                        {ch.minutesTaken} Minutes
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography fontSize={14} fontWeight={'600'}>
                                        {ch.activity}
                                    </Typography>
                                </TableCell>
                                <TableCell align="center">
                                    <NotesReadOnlyModal notes={ch.notes} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                )}

                {!isLargerThanMedium && data && (
                    <TableBody>
                        {data.data.map((ch) => (
                            <TableRow key={ch.id}>
                                <TableCell sx={{ paddingRight: '1%', paddingLeft: '2%' }}>
                                    <Typography fontSize={13} fontWeight={'600'}>
                                        {new Date(ch.date).toLocaleDateString()}
                                    </Typography>
                                </TableCell>
                                <TableCell
                                    sx={{ paddingRight: '0.313rem', paddingLeft: '0.313rem' }}>
                                    <Typography fontSize={13} fontWeight={'600'}>
                                        {ch.minutesTaken} Minutes
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ paddingRight: '0.313rem', paddingLeft: '2%' }}>
                                    <Typography fontSize={13} fontWeight={'600'}>
                                        {ch.activity}
                                    </Typography>
                                </TableCell>
                                <TableCell
                                    sx={{ paddingRight: '0.313rem', paddingLeft: '0.313rem' }}
                                    align="center">
                                    <NotesReadOnlyModal notes={ch.notes} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                )}
            </Table>
            {data && (
                <Pagination
                    shape="rounded"
                    page={data.page}
                    count={data.totalPages}
                    onChange={paginationHandler}
                />
            )}
        </TableContainer>
    );
};

const TableCell = styled(MuiTableCell)(() => ({
    borderWidth: 2,
    borderColor: 'white'
}));

const TableRow = styled(MuiTableRow)(({ theme: t }) => ({
    backgroundColor: t.palette.listItemBackground.shade
}));

export default PastCyclesAncillaryHoursTable;
